import { QuizzachLogo } from '@quizzach/assets';
import { Navigation } from '@quizzach/components';
import { useWindowListener } from '@quizzach/contexts';
import { RoutePath } from '@quizzach/interfaces';
import { fastFadeInConfig } from '@quizzach/motion';
import {
	BackgroundContainer,
	Colors,
	H2,
	Text,
	PremadeQuizzesByIdContainer,
	TextSize,
	Label,
} from '@quizzach/styles';
import { handleDownloadPromoRetrospectiveTemplate } from '@quizzach/utils';
import { motion } from 'framer-motion';
import { FaRegFile } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const PromoRetrospective = () => {
	const { t } = useTranslation();
	const { touchDevice } = useWindowListener();

	return (
		<BackgroundContainer color={Colors.surfaceMinimal}>
			<PremadeQuizzesByIdContainer
				data-id='premade-quizzes-by-id-container'
				$backgroundImage={`https://quizzach.com/uploads/thematic_quizzes/premade-retro1-6942047382f1b.webp`}
			>
				<div className='premade-quizzes-by-id-cover'>
					<Navigation />
					<motion.div
						className='premade-quizzes-content-wrapper'
						{...fastFadeInConfig()}
					>
						<div className='flex-title-tags'>
							<H2
								color={Colors.brandMain}
								className='premade-quizzes-main-headline'
								style={{ margin: 0 }}
							>
								{t('landing.retro.titleAccent')}
							</H2>
							<H2
								color={Colors.white}
								className='premade-quizzes-main-headline'
								style={{ margin: 0 }}
							>
								{t('landing.retro.title')}
							</H2>
						</div>
						<Text
							$size={TextSize.l}
							color={Colors.white}
							style={{ margin: '10px 0px' }}
						>
							{t('landing.retro.subtitle')}
						</Text>
						<div className='premade-quizzes-info'>
							<Text
								$size={touchDevice ? TextSize.s : TextSize.m}
								color={Colors.white}
								style={{ margin: 0 }}
							>
								{t('landing.retro.description')}
							</Text>
							<br />
							<Label onClick={() => handleDownloadPromoRetrospectiveTemplate()}>
								<FaRegFile size={15} color={'#00ffc2'} />
								<Text
									$size={touchDevice ? TextSize.xs : TextSize.s}
									color={Colors.textBrand}
									style={{ margin: 0 }}
								>
									{t('landing.retro.printableNote')}
								</Text>
							</Label>
							<div className='flex'>
								<Text
									$size={touchDevice ? TextSize.s : TextSize.m}
									color={Colors.white}
									style={{ margin: 0 }}
								>
									{t('landing.retro.author')}
								</Text>
								<div>
									<Link
										style={{ all: 'unset', cursor: 'pointer' }}
										to={`${RoutePath.PremadeQuizzes}/author/quizzach`}
									>
										<QuizzachLogo
											width={90}
											className='premade-quiz-info-logo'
										/>
									</Link>
								</div>
							</div>
							<div className='flex'>
								<Text
									$size={touchDevice ? TextSize.s : TextSize.m}
									color={Colors.white}
									style={{ margin: 0 }}
								>
									{t('landing.retro.difficulty')}
								</Text>
								<div className='premade-quizzes-level'>
									{t('landing.retro.difficultyEasy')}
								</div>
								<div className='premade-quizzes-level active'>
									{t('landing.retro.difficultyMedium')}
								</div>
								<div className='premade-quizzes-level'>
									{t('landing.retro.difficultyHard')}
								</div>
							</div>
							<div className='flex'>
								<Text
									$size={touchDevice ? TextSize.s : TextSize.m}
									color={Colors.white}
									style={{ margin: 0 }}
								>
									{t('landing.retro.questionCount')}
								</Text>
								<Text
									$size={touchDevice ? TextSize.s : TextSize.m}
									color={Colors.white}
									style={{ margin: '0px 0px 0px 5px' }}
								>
									30{' '}
								</Text>
							</div>
						</div>
						<Text
							$size={touchDevice ? TextSize.m : TextSize.l}
							color={Colors.brandMain}
						>
							{t('landing.retro.downloadFree', {
								location: touchDevice
									? t('landing.retro.downloadLocationMobile')
									: t('landing.retro.downloadLocationDesktop'),
							})}{' '}
							<b>BYE-2025</b>
						</Text>
					</motion.div>
				</div>
			</PremadeQuizzesByIdContainer>
		</BackgroundContainer>
	);
};
